export async function rxAlert(message: string, clearDbFn: () => Promise<void>) {
  // eslint-disable-next-line no-alert
  if (confirm(message)) {
    await clearDbFn();
  }
}
